/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkCupStrawIcon16Light = forwardRef('FoodDrinkCupStrawIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.159 1.217A.25.25 0 0 1 9.407 1h2.843a.5.5 0 0 0 0-1H9.407a1.25 1.25 0 0 0-1.24 1.085L7.78 4H4.552a1 1 0 0 0-.995 1.1l.855 8.55A1.5 1.5 0 0 0 5.905 15h4.19a1.5 1.5 0 0 0 1.493-1.35l.855-8.55a1 1 0 0 0-.995-1.1h-2.66l.37-2.783ZM4.552 5h6.896l-.856 8.55a.5.5 0 0 1-.497.45h-4.19a.5.5 0 0 1-.498-.45L4.552 5Z" })));
});
